import { FC, useCallback, useEffect, useState } from "react";
import { LoadingButton } from "@mui/lab";
import { useAppDispatch, useAppSelector } from "../../../../../../store/hooks";
import { appliedFilterTemplateIdSelector } from "../../../../../../store/filters/selectors/filter-set/applied/appliedFilterTemplateIdSelector";
import { useAppAbility } from "../../../../../../services/permissions";
import { applyFilterTemplateToCurrentAccount } from "../../../../../../store/filters/thunks/filter-set/applyFilterSetToCurrentAccount";

interface ApplyFilterTemplateButtonProps {
  filterSetId: string;
  onApply(): void;
}

export const ApplyFilterTemplateButton: FC<ApplyFilterTemplateButtonProps> = ({
  filterSetId,
  onApply,
}) => {
  const dispatch = useAppDispatch();
  const appliedFilterSetId = useAppSelector(appliedFilterTemplateIdSelector);
  const [applying, setApplying] = useState(false);
  const { cannot } = useAppAbility();
  const cannotApplyFilterSet = cannot("apply", "filter-set");

  const [applied, setApplied] = useState(filterSetId === appliedFilterSetId);

  const applyHandler = useCallback(async () => {
    setApplying(true);
    await dispatch(applyFilterTemplateToCurrentAccount(filterSetId));
    onApply();
    setApplying(false);
  }, [dispatch, filterSetId, onApply]);

  useEffect(() => {
    setApplied(filterSetId === appliedFilterSetId);
  }, [filterSetId, appliedFilterSetId]);

  return (
    <LoadingButton
      size="small"
      loading={applying}
      variant="outlined"
      disabled={applied || cannotApplyFilterSet}
      onClick={applyHandler}
      sx={{ minWidth: 75 }}
    >
      {applied ? "Applied" : "Apply"}
    </LoadingButton>
  );
};
